import Vue from 'vue';
// import * as Sentry from '@sentry/vue';
import store from './store';
import App from './App.vue';

Vue.config.productionTip = false;

window.FasttrackCrm = new Vue({
  store,
  render: h => h(App),
}).$mount('#fasttrack-crm');

window.FasttrackCrm.getPendingBonuses = () => {
  const app = window.FasttrackCrm.$children[0];
  const pendingBonusesComponent = app.$children.find(child => child.$options.name === 'PendingRewards');

  return pendingBonusesComponent.getPendingBonuses();
};

window.FasttrackCrm.getHistoricalPendingBonsuses = () => {
  const app = window.FasttrackCrm.$children[0];
  const pendingBonusesComponent = app.$children.find(child => child.$options.name === 'PendingRewards');

  return pendingBonusesComponent.getHistoricalPendingBonsuses();
};

window.FasttrackCrm.consumePendingReward = (bonusId) => {
  const app = window.FasttrackCrm.$children[0];
  const pendingBonusesComponent = app.$children.find(child => child.$options.name === 'PendingRewards');

  return pendingBonusesComponent.consumePendingReward(bonusId);
};

window.FasttrackCrm.loggedIn = () => {
  const app = window.FasttrackCrm.$children[0];
  const crmIntegrationComponent = app.$children.find(child => child.$options.name === 'CRMIntegration');

  return crmIntegrationComponent.loggedIn(navigator.userAgent);
};

window.FasttrackCrm.registered = (urlReferer, note) => { // eslint-disable-line
  const app = window.FasttrackCrm.$children[0];
  const crmIntegrationComponent = app.$children.find(child => child.$options.name === 'CRMIntegration');

  return crmIntegrationComponent.registered(navigator.userAgent, urlReferer, note); // eslint-disable-line
};

window.FasttrackCrm.updateUserAgent = (timestamp) => {
  const app = window.FasttrackCrm.$children[0];
  const crmIntegrationComponent = app.$children.find(child => child.$options.name === 'CRMIntegration');

  return crmIntegrationComponent.updateUserAgent(timestamp, navigator.userAgent);
};

window.FasttrackCrm.paymentMade = (amount, bonusCode, currency, depositCount, exchangeRate, feeAmount, note, paymentId, status, type, vendorId, withdrawCount) => { /* eslint-disable-line */
  const app = window.FasttrackCrm.$children[0];
  const crmIntegrationComponent = app.$children.find(child => child.$options.name === 'CRMIntegration');

  return crmIntegrationComponent.paymentMade(amount, bonusCode, currency, depositCount, exchangeRate, feeAmount, note, paymentId, status, type, vendorId, withdrawCount); /* eslint-disable-line */
};

window.FasttrackCrm.bonusConsumed = (amount, bonusCode, bonusId, bonusTurnedReal, currency, exchangeRate, lockedAmount, product, requiredWageringAmount, status, type, userBonusId) => { /* eslint-disable-line */
  const app = window.FasttrackCrm.$children[0];
  const crmIntegrationComponent = app.$children.find(child => child.$options.name === 'CRMIntegration');

  return crmIntegrationComponent.bonusConsumed(amount, bonusCode, bonusId, bonusTurnedReal, currency, exchangeRate, lockedAmount, product, requiredWageringAmount, status, type, userBonusId); /* eslint-disable-line */
};

window.FasttrackCrm.toggleInbox = () => {
  const app = window.FasttrackCrm.$children[0];
  return app.toggleInbox();
};

window.FasttrackCrm.togglePendingBonusesV2 = (bonusId) => {
  const app = window.FasttrackCrm.$children[0];
  return app.togglePendingBonusesV2(bonusId);
};

window.FasttrackCrm.init = (sid, source) => {
  const app = window.FasttrackCrm.$children[0];
  return app.init(sid, source);
};

window.FasttrackCrm.logout = () => {
  const app = window.FasttrackCrm.$children[0];
  return app.logout();
};

window.FasttrackCrm.demoMessage = (params) => {
  const app = window.FasttrackCrm.$children[0];
  return app.sendDemoMessage(params);
};

window.FasttrackCrm.sendLocalNotification = (messageParams) => {
  const app = window.FasttrackCrm.$children[0];
  return app.sendLocalNotification(messageParams);
};

// Temporary disabling Sentry:
// Sentry.init({
//   Vue,
//   dsn: 'https://d5e87137513cbcf03580e51cdf1d4d16@o73390.ingest.us.sentry.io/4507740395995136',
//   environment: window.fasttrackbrand,
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.replayIntegration(),
//   ],
//   tracesSampleRate: 1.0,
// });

// Sentry.setContext('site-details', {
//   fasttrackbrand: window.fasttrackbrand,
//   sid: window.sid,
//   origin: window.origin,
//   stage: JSON.stringify(process.env.APP_ENV || 'staging'),
// });
